import React, { useCallback, useState, useContext } from "react";
import { Dropdown, Menu } from "antd";
import { ThirdAppContext, FavoviteSortType } from "@/components/ThirdApp/utils";
import IconFont from "@/components/icon";
import styles from "./index.module.less";

export default function DropdownSort(props: any) {
  let { favoriteSortType, onChangeFavoriteSortType } = useContext(ThirdAppContext);
  if (props.isCard) {
    favoriteSortType = props.favoriteSortType;
    onChangeFavoriteSortType = props.onChangeFavoriteSortType;
  }
  const [visible, setVisible] = useState(false);
  // const [curType, setCurType] = useState("1");
  const onClick = useCallback((item) => {
    onChangeFavoriteSortType?.(item.key);
    if (props.isCard) {
      setVisible(false);
    }
    // setCurType(item.key);
  }, []);
  const menu = (
    <Menu onClick={onClick}>
      <Menu.Item key={FavoviteSortType.BySort}>
        <span
          className={`${
            favoriteSortType === FavoviteSortType.BySort ? styles["dropdown_active"] : ""
          }`}
        >
          按使用频次排序
        </span>
      </Menu.Item>
      <Menu.Item key={FavoviteSortType.Favorite}>
        <span
          className={`${
            favoriteSortType === FavoviteSortType.Favorite ? styles["dropdown_active"] : ""
          }`}
        >
          按配置排序
        </span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown
      overlay={menu}
      onVisibleChange={(visible) => {
        setVisible(visible);
      }}
      trigger={["click"]}
    >
      <span className={styles["dropdown_item"]} style={props?.coustomStyle}>
        {favoriteSortType === FavoviteSortType.BySort ? "按使用频次排序" : "按配置排序"}{" "}
        {visible ? (
          <IconFont style={{ fontSize: "8px" }} type="iconjs_list_arrowup" />
        ) : (
          <IconFont style={{ fontSize: "8px" }} type="iconjs_ilist_arrowdown" />
        )}
      </span>
    </Dropdown>
  );
}
